import './style.css'
import Collection from "../../js/generic/collection";
import React, { Suspense } from "react"
import ReactDOM from "react-dom";
import { getCfg } from "../../js/utils/getCfg";
import { QueryClientProvider, QueryClient } from "react-query";
import Loader from './components/Loader'

export const instance = "[data-js-currency-chart]";

const App = React.lazy(() => import(/* webpackChunkName: "LineChart" */"./App"));

export default class CurrencyChart {

  els = {
    instance
  }

  constructor(instance) {
    this.instance = instance;
    this.cfg = getCfg(this.instance, this.els.instance);
    this.cfg.provider = new QueryClient();
    this.init();
  }

  init() {
    ReactDOM.render(
      <QueryClientProvider client={this.cfg.provider}>
        <Suspense fallback={<Loader/>}>
          <App {...this.cfg} />
        </Suspense>
      </QueryClientProvider>, this.instance
    )
  }

}

export class CurrencyChartCollection extends Collection {

  constructor() {
    super(instance, CurrencyChart);
  }

}
